import React, { useState, useRef, useEffect } from 'react';
import './CommunityDropdown.css';

const CommunityDropdown = ({ currentView, onViewChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const communityViews = ['challenges', 'clubs', 'races'];
  const isActive = communityViews.includes(currentView);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleItemClick = (view) => {
    onViewChange(view);
    setIsOpen(false);
  };

  return (
    <div className="community-dropdown" ref={dropdownRef}>
      <button
        className={`nav-link community-trigger ${isActive ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        Community
        <svg
          className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {isOpen && (
        <div className="community-menu">
          <button
            className={`community-item ${currentView === 'challenges' ? 'active' : ''}`}
            onClick={() => handleItemClick('challenges')}
          >
            <div className="community-item__content">
              <span className="community-item__title">Challenges/Goals</span>
              <span className="community-item__desc">Compete on goals</span>
            </div>
          </button>

          <button
            className={`community-item ${currentView === 'clubs' ? 'active' : ''}`}
            onClick={() => handleItemClick('clubs')}
          >
            <div className="community-item__content">
              <span className="community-item__title">Clubs</span>
              <span className="community-item__desc">Virtual running clubs</span>
            </div>
          </button>

          <button
            className={`community-item ${currentView === 'races' ? 'active' : ''}`}
            onClick={() => handleItemClick('races')}
          >
            <div className="community-item__content">
              <span className="community-item__title">Races</span>
              <span className="community-item__desc">Goals & results</span>
            </div>
          </button>

        </div>
      )}
    </div>
  );
};

export default CommunityDropdown;
